module.exports = __webpack_public_path__ + "media/images/cofinancing_entities/portugal2020-e77a8f3fa86909c5f0ed1dd97fef1a41.png";